import Modal from '../../Unknown/Modal'
import { useAppDispatch, useAppSelector } from '../../../modules/store/hooks'
import { modalsSlice } from '../../../modules/store/reducers/modalsSlice'
import translate from '../../../i18n/translate'
import { useState } from 'react'
import EventSearchView from './EventSearchView'
import BillAccountView from './BillAccountView'
import TransactionTypeView from './TransactionTypeView'
import ServiceFormView from './ServiceFormView'
import FormView from './FormView'

type CreateTransactionModalProps = {
  organizerInfo: {
    userId: number
    id: number
    earlyWithdrawalAnswerMessage?: string | null
    earlyWithdrawalDays: number
    earlyWithdrawalFee: number
    earlyWithdrawalPercent: number
    earlyWithdrawalRequestDate: Date | null
    earlyWithdrawalRequestMessage?: string | null
    freeTransactionCount: number
    isEarlyWithdrawalEnabled: boolean
    isEarlyWithdrawalRequested: boolean
    fastWithdrawalFee: number
    withdrawalType: 'default' | 'days'
    withdrawalDays: number
    transactionFee: number
    transactionMinSum: number
    adminNote?: string | null;
  }
}

export default function CreateTransactionModal({
  organizerInfo,
}: CreateTransactionModalProps) {
  const dispatch = useAppDispatch()
  const [event, setEvent] =  useState<any>(null)
  const [type, setType] =  useState<any>(null)
  const [billAccount, setBillAccount] =  useState<any>(null)
  const { toggleCreateTransactionModal } = modalsSlice.actions
  const visible = useAppSelector(state => state.modalsReducer.createTransaction)

  const onCloseModal = () => {
    dispatch(toggleCreateTransactionModal())
  }

  return (
    <Modal
      title={translate('createTransactionModalTitle')}
      visible={visible === 'open'}
      style={{ maxWidth: '600px' }}
      setVisible={onCloseModal}
    >
      {!event ? <EventSearchView setEvent={setEvent} event={event} userId={organizerInfo.userId} /> : null}
      {event && !type ? <TransactionTypeView type={type} setType={setType} /> : null}
      {event && !billAccount && type === 'simple' ? <BillAccountView setBillAccount={setBillAccount} billAccount={billAccount} userId={organizerInfo.userId} /> : null}
      {event && billAccount && type === 'simple' ? <FormView userId={organizerInfo.userId} event={event} billAccount={billAccount} onCloseModal={onCloseModal} /> : null}
      {event && type === 'service' ? <ServiceFormView userId={organizerInfo.userId} event={event} onCloseModal={onCloseModal} /> : null}
    </Modal>
  )
}
